import { inject, Pipe, PipeTransform } from '@angular/core';

import { filter } from 'lodash-es';

import { AddressEnum } from '../../enums/address';
import { PhoneAndEmailPurchaseWalkingFarmProperty, WalkingFarmProperty } from '../../typings/walking-farm';
import { AddressPipe } from './address.pipe';

@Pipe({
  name: 'redFilterWalkingFarmProperties',
  standalone: false
})
export class FilterWalkingFarmPropertiesPipe implements PipeTransform {
  private addressPipe = inject(AddressPipe);

  transform<T extends WalkingFarmProperty[] & PhoneAndEmailPurchaseWalkingFarmProperty[]>(
    value: T,
    filterText: string
  ) {
    return filter(value, (property) =>
      this.addressPipe.transform(property, AddressEnum.Full).toLowerCase().includes(filterText.toLowerCase())
    );
  }
}
